import Swiper from "swiper/bundle";
import { Autoplay, Pagination, Navigation } from "swiper/modules";



export default class SliderImg {
  constructor(el) {
    this.el = el;
    this.swiper = null;
    this.init();
  }

  init() {
    this.swiper = new Swiper(this.el.querySelector(".swiper"), {
      modules: [Autoplay, Pagination, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      autoplay: true,

      pagination: {
        el: this.el.querySelector(".swiper-pagination"),
        type: "progressbar"
      },

      navigation: {
        nextEl: this.el.querySelector(".slider-img--next"),
      },

      breakpoints: {
        768: {
          slidesPerView: 4,
        }
      }
    });
  }
}
